"use client";

import Link from "next/link";
import { useEffect, useRef, useState } from "react";

export default function AccountMenu({ email, onSignOut }: { email: string; onSignOut: () => void }) {
  const [open, setOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) return;
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) setOpen(false);
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [open]);

  return (
    <div className="relative" ref={menuRef}>
      <button
        onClick={() => setOpen((value) => !value)}
        className="px-1.5 sm:px-3 py-1.5 rounded-md text-zinc-400 hover:text-orange-300 hover:bg-zinc-800 font-semibold flex items-center gap-1 text-[11px] sm:text-sm whitespace-nowrap transition-colors"
      >
        <span className="max-w-[56px] sm:max-w-[200px] truncate">{email}</span>
        <span className="text-[10px] shrink-0">▾</span>
      </button>
      {open && (
        <div className="absolute right-0 mt-2 w-44 bg-zinc-800 border border-zinc-700 rounded-lg shadow-2xl py-1 z-50">
          <Link
            href="/settings"
            onClick={() => setOpen(false)}
            className="block px-4 py-2 text-sm text-zinc-300 hover:bg-zinc-700 hover:text-orange-400"
          >
            Settings
          </Link>
          <button
            onClick={() => { setOpen(false); onSignOut(); }}
            className="block w-full text-left px-4 py-2 text-sm text-zinc-300 hover:bg-zinc-700 hover:text-red-300"
          >
            Sign out
          </button>
        </div>
      )}
    </div>
  );
}
